<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import DecoratedHeadline from "../components/DecoratedHeadline.svelte";
	import HelpSection from "../components/HelpSection.svelte";
	import Contact from "../components/Contact.svelte";
	import ProductsFilter from "../components/ProductsFilter.svelte";
	import ProductCard from "../components/ProductCard.svelte";
	import Button from "../components/Button.svelte";
	import type { ProductsProps } from "./ProductsProps.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { tick } from "svelte";

	type $$Props = ProductsProps;

	const { products, categories, selectedCategory } = $$restProps as $$Props;

	let selected = selectedCategory?.id;

	let visibleProducts = 12;

	async function handleLoadMore(): Promise<void> {
		const referencesContainer = document.getElementById("produkty") as HTMLDivElement;

		const initialScrollHeight = referencesContainer.scrollHeight;
		const previousLastReference = referencesContainer.lastElementChild;

		visibleProducts += 4;

		await tick();
		const firstNewReference = previousLastReference?.nextElementSibling ?? referencesContainer.lastElementChild;

		if (firstNewReference) {
			const offset = 100;

			const newReferencePosition = firstNewReference.getBoundingClientRect().top + window.scrollY - offset;
			const finalScrollHeight = referencesContainer.scrollHeight;
			const heightDifference = finalScrollHeight - initialScrollHeight;

			const adjustedPosition =
				heightDifference > 0 ? Math.min(newReferencePosition, window.scrollY + heightDifference) : newReferencePosition;

			window.scrollTo({
				top: adjustedPosition,
				behavior: "smooth",
			});
		}
	}
</script>

<Layout>
	<div class="mx-auto mt-20 flex flex-col justify-center px-4">
		<DecoratedHeadline h1>Produkty</DecoratedHeadline>
		<p
			class="mx-auto my-6 max-w-[70.625rem] text-center text-lg font-bold leading-[1.25] text-[#8F8F8F] sm:text-[2rem] md:text-[3rem] lg:mb-8 lg:mt-16"
		>
			{nbspify(
				"Naše produktová nabídka zahrnuje komplexní řešení pro skladování a logistiku, navržená s důrazem na efektivitu a flexibilitu. Prozkoumejte naše systémy a vyberte si to pravé řešení pro váš sklad.",
			)}
		</p>
		<p class="text-bito-black mx-auto max-w-[50.25rem] text-center text-xs md:text-base">
			{nbspify(
				"Objevte širokou škálu skladovacích a logistických řešení od společnosti BITO. Naše produkty jsou navrženy tak, aby vyhovovaly potřebám jakéhokoli skladu, od menších skladovacích prostor po komplexní distribuční centra. S více než 175 lety zkušeností poskytujeme inovativní systémy, které zefektivňují procesy, zvyšují produktivitu a optimalizují využití prostoru. Prozkoumejte naše regálové systémy, přepravky, automatizovaná řešení a další produkty, které vám pomohou dosáhnout lepšího výkonu ve vašem podnikání.",
			)}
		</p>
	</div>

	<p class="text-primary mb-4 mt-8 text-center text-xs font-extrabold md:hidden">Filtr produktů:</p>
	<div
		class="flex grid-cols-1 flex-wrap justify-center gap-1 gap-y-2 px-4 md:mt-8 md:grid md:grid-cols-[repeat(2,21.25rem)] md:gap-x-0 md:px-8 lg:px-[2.625rem] xl:grid-cols-[repeat(4,21.25rem)]"
	>
		{#each categories.filter((item) => item.parentId === undefined) as category, index}
			<ProductsFilter {category} largeIndex={index + 1} bind:selected />
		{/each}
	</div>
	<div
		id="produkty"
		class="mx-auto mt-16 flex max-w-[100rem] scroll-mt-8 flex-wrap justify-center gap-5 gap-x-5 gap-y-16 sm:px-4 md:scroll-mt-52 md:px-6 lg:grid lg:grid-cols-3 xl:grid-cols-4"
	>
		{#each products.slice(0, visibleProducts) as product}
			{@const category = categories.find((item) => product.categoryId === item.id)}
			{#if category}
				<ProductCard {product} {category} />
			{/if}
		{/each}
	</div>

	{#if visibleProducts < products.length}
		<div class="flex w-full justify-center px-4">
			<Button variant="secondary" class="mt-10 w-full max-w-[27.5rem]" on:click={handleLoadMore}>
				{nbspify("Načíst další produkty")}
			</Button>
		</div>
	{/if}
	<div class=" mt-20 flex flex-col gap-20 lg:mt-32 lg:gap-32">
		<HelpSection />
		<Contact />
	</div>
</Layout>
